import replaceAll from 'string.prototype.replaceall';

window.global ||= window;
replaceAll.shim();
